module.exports = __webpack_public_path__ + "static/img/Visualization26.2e22a38f.png";